import React from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQPage: React.FC = () => {
  const faqs: FAQItem[] = [
    {
      question: "How do I upload images to my portfolio?",
      answer: "Navigate to your artist page, select 'Portfolio' from the navigation bar, and use the upload button to add new images. You can add titles and descriptions to each image."
    },
    {
      question: "How can I edit my portfolio images?",
      answer: "On your portfolio, click the 'Edit' button on any image to modify its title and description. Click 'Save' when you're done, or 'Delete' to remove the image."
    },
    {
      question: "What are workflows?",
      answer: "Workflows are customizable processes that help you manage your tattoo business operations, from client consultations to booking appointments and project management."
    },
    {
      question: "How do I manage my team?",
      answer: "Go to 'Blue Prints' > 'Team' to invite team members, assign roles, and manage permissions. Team members can help you with forms, workflows, and operations."
    },
    {
      question: "What is the Operations Hub?",
      answer: "The Operations Hub is your central dashboard for managing active projects, tracking workflow progress, and monitoring ongoing client interactions."
    },
    {
      question: "How do I add locations where I work?",
      answer: "Visit your artist page and navigate to 'Tours' to add and manage your working locations. This helps clients find where you'll be tattooing."
    },
    {
      question: "Can I customize forms for client consultations?",
      answer: "Yes! Go to 'Blue Prints' > 'Forms' to create custom forms for gathering client information, design preferences, and consent documentation."
    },
    {
      question: "How do followers see my work?",
      answer: "When users follow you, they can see your portfolio, flash store, styles, and tour information on your artist page."
    },
    {
      question: "What tattoo styles can I showcase?",
      answer: "You can add multiple tattoo styles to your profile (e.g., Traditional, Realism, Japanese, etc.) to help clients find artists who specialize in their preferred style."
    },
    {
      question: "How do I update my artist profile information?",
      answer: "Navigate to your artist page and select 'About' to update your bio, experience, and other profile details."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-gray-600">
            Find answers to common questions about using the platform
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow duration-200"
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {faq.question}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Still have questions?
          </h3>
          <p className="text-gray-700">
            If you couldn't find the answer you're looking for, please contact our support team
            or check the documentation for more detailed information.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
